import React, { useContext, useRef } from 'react';
import { useQuery } from '@apollo/client';

import { Context } from '@store/store';
import useClickOutside from '@utils/useClickOutside';

import {
  StyledBookmarksSidebar,
  StyledBookmarksWrapper,
  StyledBookmarksHeader,
} from './bookmarks-sidebar.styles';

import BookmarkItem from './bookmark-item';
import { GET_ALL_BOOKMARKS } from '@graphql/bookmarks';

const BookmarksSidebar = () => {
  const [state] = useContext(Context);
  const wrapperRef = useRef(null);

  useClickOutside(wrapperRef, 'bookmarks-sidebar');

  const { loading, error, data } = useQuery(GET_ALL_BOOKMARKS, {
    variables: { id: state.bookId },
  });
  if (loading)
    return (
      <StyledBookmarksSidebar sidebarWidth={state.sidebarWidth}>
        <p style={{ textAlign: 'center' }}>Загрузка закладок…</p>
      </StyledBookmarksSidebar>
    );
  if (error)
    return (
      <StyledBookmarksSidebar sidebarWidth={state.sidebarWidth}>
        <p style={{ textAlign: 'center' }}>Ошибка: {error.message}</p>
      </StyledBookmarksSidebar>
    );
  return (
    <StyledBookmarksSidebar
      isOpened={state.isBookmarksSidebarOpened}
      data-is-opened={state.isBookmarksSidebarOpened}
      sidebarWidth={state.sidebarWidth}
      ref={wrapperRef}
    >
      <StyledBookmarksHeader>
        Закладки ({data?.book?.bookmarks.length})
      </StyledBookmarksHeader>
      <StyledBookmarksWrapper>
        {data?.book?.bookmarks?.map(bookmark => (
          <BookmarkItem
            key={bookmark.ts}
            page={bookmark.page}
            text={bookmark.text}
            ts={bookmark.ts}
          />
        ))}
      </StyledBookmarksWrapper>
    </StyledBookmarksSidebar>
  );
};

export default BookmarksSidebar;
